import type {
    GenericObject,
    RADEnvironmentProxy,
} from 'radpresentation.htmlclient.defaultviewextensions';
import {
    ComponentManager,
    ControlFactory,
} from 'radpresentation.htmlclient.defaultviewextensions';
import ExtensionEditorViewModel from '@/ViewModels/Controls/ExtensionEditorViewModel';
import ExtensionEditorControl from '@/Controls/ExtensionEditor';
class ExtensionEditorFactory extends ControlFactory {
    public viewModel: ExtensionEditorViewModel;
    public control: ExtensionEditorControl;

    private baseClass;

    constructor(params: any) {
        // type
        super(params);
    }

    public getControl(): JQuery {
        this.viewModel = this.createViewModel();
        this.control = this.createControl(this.viewModel);

        let controlHtmlElement = this.getControlHtmlElement(this.control);

        return controlHtmlElement;
    }

    private createViewModel(): ExtensionEditorViewModel {
        let genericObject = this.getGenericObject();

        let viewModelParameter = {
            context: this.context,
            locator: this.locator,
        };

        return new ExtensionEditorViewModel(viewModelParameter);
    }

    private createControl(
        viewModel: ExtensionEditorViewModel
    ): ExtensionEditorControl {
        return new ExtensionEditorControl(viewModel);
    }

    private getControlHtmlElement(control: ExtensionEditorControl): JQuery {
        return control.getTuple().control;
    }

    private getGenericObject(): GenericObject {
        let context = this.context;
        let genericObject = context.genericObject;

        return genericObject;
    }
}

export default ExtensionEditorFactory;
ComponentManager.setFactory(
    'RADExtensionManagerViewExtension.Controls.ExtensionEditor',
    ExtensionEditorFactory,
    'RADExtensionManagerHTMLViewExtension'
);
ComponentManager.setFactory(
    'RADExtensionManagerViewExtension.Controls.ExtensionEditorFactory',
    ExtensionEditorFactory,
    'RADExtensionManagerHTMLViewExtension'
);

ComponentManager.setFactory(
    'RADExtensionManagerHTMLViewExtension.Controls.ExtensionEditor',
    ExtensionEditorFactory,
    'RADExtensionManagerHTMLViewExtension'
);
ComponentManager.setFactory(
    'RADExtensionManagerHTMLViewExtension.Controls.ExtensionEditorFactory',
    ExtensionEditorFactory,
    'RADExtensionManagerHTMLViewExtension'
);
